export const BEGIN_LOADING_CUSTOMER = "BEGIN_LOADING_CUSTOMER";
export const SUCCESS_LOADING_CUSTOMER = "SUCCESS_LOADING_CUSTOMER";
export const ERROR_LOADING_CUSTOMER = "ERROR_LOADING_CUSTOMER";

export const BEGIN_LOADING_SCHEDULING_EMAIL_SNIPPET = "BEGIN_LOADING_SCHEDULING_EMAIL_SNIPPET";
export const SUCCESS_LOADING_SCHEDULING_EMAIL_SNIPPET = "SUCCESS_LOADING_SCHEDULING_EMAIL_SNIPPET";
export const ERROR_LOADING_SCHEDULING_EMAIL_SNIPPET = "ERROR_LOADING_SCHEDULING_EMAIL_SNIPPET";

export const BEGIN_SAVING_SCHEDULING_EMAIL_SNIPPET = "BEGIN_SAVING_SCHEDULING_EMAIL_SNIPPET";
export const SUCCESS_SAVING_SCHEDULING_EMAIL_SNIPPET = "SUCCESS_SAVING_SCHEDULING_EMAIL_SNIPPET";
export const ERROR_SAVING_SCHEDULING_EMAIL_SNIPPET = "ERROR_SAVING_SCHEDULING_EMAIL_SNIPPET";

export const BEGIN_SAVING_EMAIL = "BEGIN_SAVING_EMAIL";
export const SUCCESS_SAVING_EMAIL = "SUCCESS_SAVING_EMAIL";
export const ERROR_SAVING_EMAIL = "ERROR_SAVING_EMAIL";

export const BEGIN_GETTING_RELATED = "BEGIN_GETTING_RELATED";
export const SUCCESS_GETTING_RELATED = "SUCCESS_GETTING_RELATED";
export const ERROR_GETTING_RELATED = "ERROR_GETTING_RELATED";

export const BEGIN_GETTING_TOKENS = "BEGIN_GETTING_TOKENS";
export const SUCCESS_GETTING_TOKENS = "SUCCESS_GETTING_TOKENS";
export const ERROR_GETTING_TOKENS = "ERROR_GETTING_TOKENS";

export const BEGIN_EMAIL_PREVIEW = "BEGIN_EMAIL_PREVIEW";
export const SUCCESS_EMAIL_PREVIEW = "SUCCESS_EMAIL_PREVIEW";
export const ERROR_EMAIL_PREVIEW = "ERROR_EMAIL_PREVIEW";

export const BEGIN_SAVING_MMS = "BEGIN_SAVING_MMS";
export const SUCCESS_SAVING_MMS = "SUCCESS_SAVING_MMS";
export const ERROR_SAVING_MMS = "ERROR_SAVING_MMS";

export const BEGIN_MMS_PREVIEW = "BEGIN_MMS_PREVIEW";
export const SUCCESS_MMS_PREVIEW = "SUCCESS_MMS_PREVIEW";
export const ERROR_MMS_PREVIEW = "ERROR_MMS_PREVIEW";

export const BEGIN_LOADING_CHECKLIST_ITEMS = "BEGIN_LOADING_CHECKLIST_ITEMS";
export const SUCCESS_LOADING_CHECKLIST_ITEMS = "SUCCESS_LOADING_CHECKLIST_ITEMS";
export const ERROR_LOADING_CHECKLIST_ITEMS = "ERROR_LOADING_CHECKLIST_ITEMS";

export const BEGIN_LOADING_CHECKLIST_ITEM = "BEGIN_LOADING_CHECKLIST_ITEM";
export const SUCCESS_LOADING_CHECKLIST_ITEM = "SUCCESS_LOADING_CHECKLIST_ITEM";
export const ERROR_LOADING_CHECKLIST_ITEM = "ERROR_LOADING_CHECKLIST_ITEM";

export const BEGIN_UPLOADING_FILE = "BEGIN_UPLOADING_FILE";
export const SUCCESS_UPLOADING_FILE = "SUCCESS_UPLOADING_FILE";
export const ERROR_UPLOADING_FILE = "ERROR_UPLOADING_FILE";

export const BEGIN_DELETING_FILE = "BEGIN_DELETING_FILE";
export const SUCCESS_DELETING_FILE = "SUCCESS_DELETING_FILE";
export const ERROR_DELETING_FILE = "ERROR_DELETING_FILE";

export const BEGIN_UPDATING_USER = "BEGIN_UPDATING_USER";
export const SUCCESS_UPDATING_USER = "SUCCESS_UPDATING_USER";
export const ERROR_UPDATING_USER = "ERROR_UPDATING_USER";

export const BEGIN_LOADING_RELATED_CONTACTS = "BEGIN_LOADING_RELATED_CONTACTS";
export const SUCCESS_LOADING_RELATED_CONTACTS = "SUCCESS_LOADING_RELATED_CONTACTS";
export const ERROR_LOADING_RELATED_CONTACTS = "ERROR_LOADING_RELATED_CONTACTS";

export const HOLD_ONE_TIME_ACTION = "HOLD_ONE_TIME_ACTION";
export const RESOLVE_ONE_TIME_ACTION = "RESOLVE_ONE_TIME_ACTION";
export const NOOP_ONE_TIME_ACTION = "NOOP_ONE_TIME_ACTION";

export const BEGIN_UPDATING_CHECKLIST_ANSWER_INVITATION = "BEGIN_UPDATING_CHECKLIST_ANSWER_INVITATION";
export const SUCCESS_UPDATING_CHECKLIST_ANSWER_INVITATION = "SUCCESS_UPDATING_CHECKLIST_ANSWER_INVITATION";
export const ERROR_UPDATING_CHECKLIST_ANSWER_INVITATION = "ERROR_UPDATING_CHECKLIST_ANSWER_INVITATION";

export const BEGIN_LOADING_SCHOOL = "BEGIN_LOADING_SCHOOL";
export const SUCCESS_LOADING_SCHOOL = "SUCCESS_LOADING_SCHOOL";
export const ERROR_LOADING_SCHOOL = "ERROR_LOADING_SCHOOL";

export const BEGIN_LOADING_APPLICATIONS = "BEGIN_LOADING_APPLICATIONS";
export const SUCCESS_LOADING_APPLICATIONS = "SUCCESS_LOADING_APPLICATIONS";
export const ERROR_LOADING_APPLICATIONS = "ERROR_LOADING_APPLICATIONS";

export const STRIPE_JS_URL = "https://js.stripe.com/v3/";

export const MONTHS = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12
};

export const MOBILE_BREAKPOINT = 768;
